import request from '@/plugins/request'

export const infoPage = (data) => {
  return request({
    url: '/pick-up/page',
    method: 'get',
    params: data
  })
}

export const update = (data) => {
  return request({
    url: '/pick-up/save',
    method: 'post',
    data: data
  })
}

export const getInfo = (id) => {
  return request({
    url: `/pick-up/${id}`,
    method: 'get'
  })
}

export const remove = (data) => {
  return request({
    url: '/pick-up/remove',
    method: 'post',
    data: data
  })
}